import { useQuery } from '@tanstack/react-query'
import { api } from '@astro/api'

/** GET /featured-products — first few shop products for cross-sell CTAs.
 * Returns [] while loading / on error / when the API has none, so sections
 * can simply hide themselves. */
export function useFeaturedProducts(count = 4) {
  const query = useQuery({
    queryKey: ['featured-products', count],
    queryFn: () => api.catalog.featured(),
    staleTime: 10 * 60 * 1000,
    select: (res) => {
      const rows = res?.data?.data ?? res?.data ?? []
      return (Array.isArray(rows) ? rows : []).slice(0, count)
    },
  })
  return {
    products: query.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
  }
}
